import { createFileRoute, redirect } from '@tanstack/react-router';

import { billingPageOpens } from '@/lib/billing/app-store-access';
import { usesWebBilling } from '@/lib/native/purchase-visibility';
import { useSessionStore } from '@/lib/stores/session.store';
import AppStorePage from '@/screens/settings/billing/app-store/page';
import Page from '@/screens/settings/billing/page';

/** The Stripe billing on the web and for super-admins, the App Store's in the iOS app (KAN-10). */
function BillingPage() {
  const profile = useSessionStore((state) => state.profile);
  return usesWebBilling(profile) ? <Page /> : <AppStorePage />;
}

export const Route = createFileRoute('/_app/settings/billing/')({
  beforeLoad: () => {
    // The billing page on the web; in the iOS app the App-Store screen when it
    // has something to offer; nothing in the Android app — see
    // lib/billing/app-store-access and lib/native/purchase-visibility.
    if (!billingPageOpens()) throw redirect({ to: '/settings/personal' });
  },
  component: BillingPage,
});
